import React, { useState } from "react";
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { Button, PageTable, Title } from "@src/components";
import { getColumns } from "./LectureListColumns";
import { initLectureListFilters, useLectureList } from "./service";
import { LectureListFilterType } from "./service/types";

const Lectures = () => {
    const navigate = useNavigate();
    const columns = getColumns(navigate);

    const [params, setParams] = useState<LectureListFilterType>(initLectureListFilters);

    const { data } = useLectureList(params);

    return (
        <div css={listStyle}>
            <Title title="오프라인 강의 관리" />
            <div css={btnBoxStyle}>
                <Button
                    color="purple"
                    size="medium"
                    label="강의 등록"
                    handleClick={() => {
                        navigate("/offline/create");
                    }}
                />
            </div>
            <div css={tableDivStyle}>
                <PageTable
                    columns={columns}
                    data={data?.list ?? []}
                    initialState={{
                        pageIndex: 0,
                        pageSize: params.limit,
                    }}
                    FixedHeight={500}
                    showTotalCount={true}
                    totalCount={data?.totalCnt ?? 0}
                    handlePageChange={(index: number) => {
                        const page = index + 1;
                        setParams({ ...params, page });
                    }}
                    forcePageNumber={params.page}
                ></PageTable>
            </div>
        </div>
    );
};

export default Lectures;

const listStyle = css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 40px;
`;

const btnBoxStyle = css`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-top: 10px;
`;

const tableDivStyle = css`
    margin-top: 43px;
    width: 100%;
    height: 80vh;
`;

const countDivStyle = css`
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
`;
